import _ from 'underscore';
import type { PropertyName } from '../types';

function castPath(value: string | PropertyName[], object: object): PropertyName[] {
  if (_.isArray(value)) {
    return value;
  }

  if (_.has(object, value)) {
    return [value];
  }

  return _.compact(value.split(/[[\].]/)) as string[];
}

export function get<TResult, TDefault>(
  object: object,
  path: string | PropertyName[],
  defaultValue: TDefault,
): TResult | TDefault {
  let sub: unknown;
  let i;
  const keyPath = castPath(path, object);

  for (i = 0, sub = object; i < keyPath.length; i += 1) {
    if (!_.isObject(sub)) {
      return defaultValue;
    }

    sub = (sub as Record<PropertyName, unknown>)[keyPath[i]];

    if (_.isUndefined(sub)) {
      return defaultValue;
    }
  }

  return sub as TResult;
}
